import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import useInterval from "../container/useInterval";
import { ClipLoader } from "react-spinners";
import { Machine, Field } from "../api";
import { useFeatureGuide } from '../hooks/useFeatureGuide.js';
import MachineLine from "../container/Machine";
import PageDirector from "../container/PageDirector";
import { useGlobal } from "../global/user";
import { Form, Select, Input, InputNumber, Modal, Space, Button } from "antd";
import FieldSelect from "../container/SelectField";
import Header from "../container/Header";
import Footer from "../container/Footer";
const { Option } = Select;
const control_function_type = ["1", "5"];

// 不需要填 port / socket_port 的機具類型（需與後端 machine.py NO_SOCKET_TYPES 一致）
const NO_SOCKET_TYPES = [3, 8, 9, 10, 11, 12, 13];

export default function Control() {
  const [MachineList, setMachines] = useState([]);
  const [deviceType, setDeviceType] = useState(0);
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  const [onNewMachine, setOnnewMachine] = useState(false);
  const { user, field, fields } = useGlobal();
  const [keyword, setKeyword] = useState("");
  const Keyword = useRef();

  const location = useLocation();
  const [activeTab, setActiveTab] = useState("1");
  const [restoredFieldData, setRestoredFieldData] = useState(null);

  const stepsFromLocal = location.state?.restoreData?.pathSteps || [];
  useFeatureGuide({ 
    location, 
    setActiveTab, 
    setRestoredFieldData,
    stepsFromDB: stepsFromLocal 
  });

  useInterval(() => {
    (async () => {
      if (!user || !user.class) return;
      if (fields.length === 0) {
        setLoading(false);
        return;
      }
      let response = await Field.GetFieldData(field, user.class);
      if (user.class < process.env.REACT_APP_EDITOR_CALSS_LV) {
        response.data.forEach((machine) => {
          if (!Array.isArray(machine.functions)) machine.functions = [];
          machine.functions = machine.functions.filter((func) => !control_function_type.includes(func.type));
        });
      }
      setLoading(false);
      setMachines(response.data);
    })();
  }, 1000 * 10 * 60);
  const formItemLayout = {
    labelCol: {
      sm: {
        span: 5,
      },
    },
    wrapperCol: {
      sm: {
        span: 15,
      },
    },
  };
  const submitNewMachine = async () => {
    const machineInfo = form.getFieldsValue();
    machineInfo.field_id = field;
    try {
      const response = await Machine.CreateMachine(machineInfo);
      console.log(response);
      if (response.code === 200) setMachines((data) => [...data, response.data.machine]);
    } catch (error) {
      alert(error.response.data.message);
    }
    setOnnewMachine(false);
  };
  useEffect(() => {
    (async () => {
      if (!user || !user.class) return;
      if (fields.length === 0) {
        setLoading(false);
        return;
      }
      let response = await Field.GetFieldData(field, user.class);
      if (user.class < process.env.REACT_APP_EDITOR_CALSS_LV) {
        response.data.forEach((machine) => {
          if (!Array.isArray(machine.functions)) machine.functions = [];
          machine.functions = machine.functions.filter((func) => !control_function_type.includes(func.type));
        });
      }
      setLoading(false);
      setMachines(response.data);
    })();
  }, [user, field]);

  return (
    <React.Fragment>
      <Header />
      <div className="container-fluid">
        <div className="page-container fade-in">
          <PageDirector />
          <FieldSelect />
          <div className="button-group-right">
            <Input 
              className="search-input" 
              placeholder="輸入關鍵字" 
              ref={Keyword} 
            />
            <Button
              type="default"
              onClick={() => {
                setKeyword(Keyword.current.state.value);
              }}
              style={{
                background: "var(--content-background)",
                color: "var(--primary-text)",
                border: "2px solid var(--primary-border)"
              }}
            >
              查詢
            </Button>
            {user.class >= process.env.REACT_APP_CONTROL_CALSS_LV && (
              <Button 
                type="default" 
                onClick={() => setOnnewMachine(true)}
                style={{ 
                  marginLeft: "8px",
                  background: "var(--content-background)",
                  color: "var(--primary-text)",
                  border: "2px solid var(--primary-border)"
                }}
              >
                新增機具
              </Button>
            )}
          </div>
          <Space direction="vertical" style={{ width: "100%" }}>
            <div className="ant-table-wrapper">
              <div className="ant-spin-nested-loading">
                <div className="ant-spin-container">
                  <div className="ant-table ant-table-bordered">
                    <div className="ant-table-container">
                      <div className="ant-table-content" style={{ overflowX: "auto" }}>
                        <table className="table_group" style={{ tableLayout: "auto", minWidth: "100%" }}>
                          <thead className="ant-table-thead">
                            <tr>
                              <th className="ant-table-cell ant-table-cell-fix-left" style={{ width: 260, textAlign: "center" }}>
                                設備名稱
                              </th>
                              <th className="ant-table-cell" style={{ width: 600, textAlign: "center" }}>
                                設備內容
                              </th>
                              <th className="ant-table-cell" style={{ textAlign: "center" }}>
                                設備狀態
                              </th>
                              <th className="ant-table-cell" style={{ textAlign: "center" }}>
                                設備設定
                              </th>
                            </tr>
                          </thead>
                          <tbody className="ant-table-tbody">
                            {loading ? (
                              <tr>
                                <td className="ant-table-cell" colSpan={4} style={{ textAlign: "center" }}>
                                  <div style={{ height: 150, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <ClipLoader size={150} />
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              MachineList
                              .filter((machine) => keyword === "" || machine.mobile_name.includes(keyword))
                              .filter((machine) => Array.isArray(machine.functions) && machine.functions.length > 0)
                              .map((data) => (
                                <MachineLine key={`Machine-${data.id}`} id={data.id} data={data} setMachines={setMachines} fd={data.field_id} />
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Space>
          <Footer />
        </div>
      </div>
      <Modal
        title="新增機具"
        open={onNewMachine}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => setOnnewMachine(false)}
      >
        <Form {...formItemLayout} form={form} onFinish={submitNewMachine}>
          <Form.Item
            name="mobileType"
            label="機具類型"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: "請選擇新增機具項目",
              },
            ]}
          >
            <Select
              onChange={(value) => {
                setDeviceType(value);
                console.log(deviceType);
              }}
            >
              <Option value={1}>索道權限</Option>
              <Option value={2}>室內定位</Option>
              <Option value={3}>影像機具</Option>
              <Option value={4}>電源權限</Option>
              <Option value={5}>數位油壓</Option>
              <Option value={6}>電源控制</Option>
              <Option value={7}>儲量監測</Option>
              <Option value={8}>水情影像</Option>
              <Option value={9}>MQTT油壓</Option>
              <Option value={10}>門禁機具</Option>
              <Option value={11}>MQTT機具</Option>
              <Option value={12}>紅外線鏡頭</Option>
              <Option value={13}>鹽霧害影像機具</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="name"
            label="機具名稱"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: "請輸入機具名稱",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="IP"
            label="IP"
            labelAlign="left"
            defaultValue={"1.iotwebhub.net"}
            rules={[
              {
                required: true,
                message: "請輸入機具IP",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="port"
            label="通訊埠"
            labelAlign="left"
            rules={
              NO_SOCKET_TYPES.includes(deviceType)
                ? []
                : [
                    {
                      required: true,
                      message: "請輸入通訊埠為1~65535的數字",
                    },
                    {
                      type: "number",
                      max: 65535,
                      min: 1,
                      message: "請輸入通訊埠為1~65535的數字",
                    },
                  ]
            }
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            name="socket_port"
            label="機具埠"
            labelAlign="left"
            rules={
              NO_SOCKET_TYPES.includes(deviceType)
                ? []
                : [
                    {
                      required: true,
                      message: "請輸入機具埠為1~65535的數字",
                    },
                    {
                      type: "number",
                      max: 65535,
                      min: 1,
                      message: "請輸入機具埠為1~65535的數字",
                    },
                  ]
            }
          >
            <InputNumber />
          </Form.Item>
        </Form>
      </Modal>
    </React.Fragment>
  );
}
